import { __assign, __rest } from "tslib";
import * as React from 'react';
import MUITooltip from '@material-ui/core/Tooltip';
import classnames from 'classnames';
import { useTheme } from '../theme';
import { ClickAwayListener } from '@material-ui/core';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_MIN_WIDTH } from '../utils';
import { useToggleable } from '../hooks';
var Tooltip = function (_a) {
    var title = _a.title, children = _a.children, titleClassName = _a.titleClassName, tooltipClassName = _a.tooltipClassName, popperClassName = _a.popperClassName, _b = _a.placement, placement = _b === void 0 ? 'top' : _b, restProps = __rest(_a, ["title", "children", "titleClassName", "tooltipClassName", "popperClassName", "placement"]);
    var css = useTheme('Tooltip').Tooltip;
    var isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });
    var _c = useToggleable(false), isOpen = _c.isOpen, toggle = _c.toggle, close = _c.close;
    var timer = React.useRef(null);
    var handleTooltipClick = function () {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        if (!isOpen) {
            timer.current = setTimeout(function () {
                close();
            }, title.toString().length * 60 + 2000);
        }
        toggle();
    };
    var handleClickAway = function () {
        close();
        if (timer.current) {
            clearTimeout(timer.current);
        }
    };
    var Tooltip = (React.createElement(MUITooltip, __assign({ title: React.createElement("span", { className: classnames(css.title, titleClassName) }, title), placement: placement, arrow: true, PopperProps: {
            modifiers: {
                flip: {
                    enabled: false
                },
                preventOverflow: {
                    escapeWithReference: false
                }
            }
        }, classes: {
            tooltip: classnames(css.tooltip, tooltipClassName),
            popper: classnames(css.popper, popperClassName),
            arrow: css.tooltip_arrow
        }, open: isMobile ? isOpen : undefined }, restProps), children));
    if (isMobile) {
        return (React.createElement(ClickAwayListener, { onClickAway: handleClickAway },
            React.createElement("span", { className: css.tooltip_wrapper, onClick: handleTooltipClick }, Tooltip)));
    }
    return Tooltip;
};
export default Tooltip;
